module.exports = __webpack_public_path__ + "static/media/6.41b6f30e.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/intro/mobile/6.png
// module id = 2505
// module chunks = 0